<template>
    <div class="d-flex justify-content-between align-items-center mb-2 gap-2">
        <input type="text" class="form-control" placeholder="Text" v-model="choice_text" />
        <input type="text" class="form-control" placeholder="Value" v-model="choice_value" />
        <input type="number" class="form-control" placeholder="Order" v-model="choice_order" :max="max_order" />
        <i class="bi bi-trash hoverable-icon text-danger w-auto height-100" @click="$emit('removeChoice', { uuid: props.uuid })"></i>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";

const props = defineProps({
    uuid: String,
    max_order: Number,
    choice: Object,
});

const choice_text = ref(props.choice && props.choice.text ? props.choice.text : '');
const choice_value = ref(props.choice && props.choice.value ? props.choice.value : '');
const choice_order = ref(props.choice && props.choice.order ? props.choice.order : 1);

const emits = defineEmits(['choiceFieldUpdated', 'removeChoice']);

watch(choice_text, (val) => {
    emits('choiceFieldUpdated', { uuid: props.uuid, value: choice_text.value, field: 'text' });
});
watch(choice_value, (val) => {
    emits('choiceFieldUpdated', { uuid: props.uuid, value: choice_value.value, field: 'value' });
});
watch(choice_order, (val) => {
    if (val <= props.max_order) {
        emits('choiceFieldUpdated', { uuid: props.uuid, value: choice_order.value, field: 'order' });
    }
    else {
        choice_order.value = props.max_order;
        emits('choiceFieldUpdated', { uuid: props.uuid, value: props.max_order, field: 'order' });
    }
});

onMounted(() => {
})
</script>